const GLightbox = require('glightbox');

export interface LazyLoaderConfig {
    thumbs: string;
    paging: string;
    button: HTMLElement;
}

export class LazyLoader {
    protected selectors: {
        thumbs: string;
        paging: string;
    };
    protected readonly elements: {
        thumbs: HTMLElement;
        paging: HTMLElement;
        button: HTMLElement;
    };

    constructor({thumbs, paging, button}: LazyLoaderConfig) {
        this.selectors = {thumbs, paging};
        this.elements = {
            thumbs: document.querySelector(this.selectors.thumbs),
            paging: document.querySelector(this.selectors.paging),
            button
        };
        this.init();
    }

    public getUrl(): string {
        const paging = document.querySelector(this.selectors.paging);
        const current = paging.querySelector(`li.selected`);
        const next = current.nextElementSibling;

        if (!next) return undefined;
        return next.querySelector(`a`).getAttribute(`href`);
    }

    protected setGLightBox() {
        return GLightbox({
            selector: `${this.selectors.thumbs} a`,
            skin: '',
            svg: {
                close:
                    '',
                next:
                    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40"><path d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z"></path></svg>',
                prev:
                    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40"><path d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z"></path></svg>'
            }
        });
    }

    protected uploadItems(lightbox: any) {
        const url = this.getUrl();

        if (url) {
            const spinner = this.elements.button.nextElementSibling;
            spinner.classList.add(`is-active`);

            fetch(url)
                .then(response => {
                    return response.text()
                })
                .then(html => {
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(html, "text/html");
                    const paging = document.querySelector(this.selectors.paging);
                    const tempPaging = doc.querySelector(this.selectors.paging);
                    const thumbs = doc.querySelector(this.selectors.thumbs).innerHTML;

                    paging.replaceWith(tempPaging);
                    this.elements.thumbs.insertAdjacentHTML('beforeend', thumbs);
                    spinner.classList.remove(`is-active`);

                    lightbox.reload();
                    if (!this.getUrl()) this.elements.button.remove();
                })
                .catch(function (error) {
                    console.error('Failed to fetch page: ', error);
                });
        }
    }

    protected init(): void {
        const lightbox = this.setGLightBox();

        if (!this.elements.thumbs || !this.elements.paging) return;
        this.elements.button.addEventListener(`click`, () => this.uploadItems(lightbox));
    }
}